import React from 'react'
import { ActivityIndicator } from 'react-native'

import { BottomSheet, SH1, Stack, XStack } from '@zet/design-system'
import Close from '@zet/design-system/svg/Close'
import RupeeCircleOutlined from '@zet/design-system/svg/RupeeCircleOutlined'
import { useLeadsTransactionHistory } from '@zet/feature-leads/api/leadDetails/hooks'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'
import { FlatList } from 'react-native-gesture-handler'

import PayoutCards from './payoutCard'

const PAGE = 1
const LIMIT = 5
const TotalTransactionBottomSheet = ({
  setOpenBottomSheet,
  openBottomSheet,
  item: leadDetails,
  totalCommission,
}: {
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>
  openBottomSheet: boolean
  item?: object
  totalCommission: number
}) => {
  const {
    data,
    fetchNextPage,
    refetch,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
  } = useLeadsTransactionHistory(leadDetails?.id, PAGE, LIMIT)
  const payment = data?.pages?.flatMap((page) => page.payoutTransactions)
  function closeBSheet() {
    setOpenBottomSheet(false)
  }
  return (
    <BottomSheet
      visible={openBottomSheet}
      disableBottomSheet={closeBSheet}
      bodyStyle={{ height: DEVICE_HEIGHT * 0.7 }}
    >
      <XStack className="border-grays-30 items-center  justify-between border-b px-3 py-2">
        <XStack className="items-center">
          <RupeeCircleOutlined className="mr-2" />
          <SH1>
            {i18n.t('payoutBreakoutLoyalty.amountReceived')}
            {totalCommission}
          </SH1>
        </XStack>
        <Close onPress={closeBSheet} />
      </XStack>
      <Stack className="flex-1">
        <FlatList
          legacyImplementation={false}
          renderItem={({ item, index }) => (
            <PayoutCards item={item} data={data} leadDetails={leadDetails} />
          )}
          data={payment}
          onEndReached={() => {
            if (!isFetching && hasNextPage) {
              fetchNextPage()
            }
          }}
          onEndReachedThreshold={1}
          onRefresh={refetch}
          refreshing={isFetching}
          keyExtractor={(item, index) => `${item?.commision} +${index}`}
          ListFooterComponent={
            <Stack className="h-[50]">
              {isFetchingNextPage ? (
                <ActivityIndicator
                  style={{ marginTop: 18 }}
                  size={'large'}
                  color="#2075F0"
                />
              ) : (
                <></>
              )}
            </Stack>
          }
        />
      </Stack>
    </BottomSheet>
  )
}

export default TotalTransactionBottomSheet
